import { findElementByText, normalizeText } from "./domUtils";

const dataUrlToBlob = async (dataUrl) => {
  const response = await fetch(dataUrl);
  if (!response.ok) throw new Error("Arquivo indisponível");
  return response.blob();
};

export const openEmployeeFilePreview = async (anchor, event) => {
  const form = anchor.closest("form");
  const modalContainer =
    form?.closest('[role="dialog"]') || form?.parentElement?.parentElement;
  const modalHeading = modalContainer
    ? findElementByText(
        "h2",
        (text) => text === "editar colaborador" || text === "novo colaborador",
        modalContainer,
      )
    : null;
  if (!form || !modalHeading || !form.contains(anchor)) return false;
  if (!normalizeText(anchor.textContent).includes("visualizar")) return false;

  event.preventDefault();
  event.stopPropagation();
  const previewWindow = window.open("", "_blank");
  if (!previewWindow) {
    window.alert(
      "O navegador bloqueou a janela de visualização. Permita pop-ups para este sistema.",
    );
    return true;
  }

  const href = anchor.getAttribute("href") || "";
  try {
    if (!href.startsWith("data:")) {
      previewWindow.location.href = href;
      return true;
    }
    previewWindow.document.title = "Carregando arquivo...";
    previewWindow.document.body.innerHTML =
      "<p style='font-family:Arial,sans-serif;padding:24px'>Carregando arquivo...</p>";
    const blob = await dataUrlToBlob(href);
    const objectUrl = URL.createObjectURL(blob);
    previewWindow.location.replace(objectUrl);
    window.setTimeout(() => URL.revokeObjectURL(objectUrl), 60_000);
  } catch (error) {
    previewWindow.close();
    window.alert(
      "Não foi possível visualizar este arquivo. Tente baixá-lo novamente.",
    );
  }
  return true;
};
